var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 19.8656,
    viewBox: "0 0 18 19.8656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.177 15.026L4.5 19.459C3.245 20.184 1.794 19.885 0.887 18.993L8.51 11.349L12.177 15.026ZM7.099 9.93295L0.00600004 17.044C0.00215886 16.9834 0.000157893 16.9227 0 16.862V3.00395C0 2.94195 0.00200004 2.88029 0.00600004 2.81895L7.099 9.93295ZM16.5 7.33495C18.5 8.48995 18.5 11.375 16.5 12.531L13.969 13.991L9.922 9.93396L13.97 5.87395L16.5 7.33495ZM0.888 0.871955C1.795 -0.0200453 3.246 -0.318045 4.5 0.406955L12.179 4.83995L8.511 8.51696L0.888 0.871955Z",
    fill: "#0D3B66"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.6f02787b74ed38a58883b858b1d17882.svg";
export { ForwardRef as ReactComponent };